import React, { useContext } from "react";
import { useParams } from "react-router-dom";
import { CartContext } from "../contexts/CartContext";
import { ProductContext } from "../contexts/ProductContext";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { toast } from "react-hot-toast";

const ProductDetails = () => {
  const { slug } = useParams();
  const { addToCart } = useContext(CartContext);
  const { products } = useContext(ProductContext);

  const product = products.find((item) => item.slug === slug);

  if (!product) {
    return (
      <section className="h-screen flex justify-center items-center">
        Loading...
      </section>
    );
  }

  const { title, price, description, image } = product;

  return (
    <>
      <Header />
      <div className="pt-[40px] lg:pt-[40px]">
        <section className="py-16 md:py-24 lg:py-16">
          <div className="container mx-auto">
            <div className="flex flex-col lg:flex-row items-center bg-white p-8 rounded-lg ">
              <div className="flex  bg-[#f6f6f6] flex-1 justify-center items-center mb-8 lg:mb-0">
                <img
                  className="max-w-full lg:max-w-md rounded-lg "
                  src={image}
                  alt={title}
                />
              </div>
              <div className="flex-1 text-center lg:text-left lg:pl-10">
                <h1 className="text-3xl font-bold mb-4 text-gray-800">
                  {title}
                </h1>
                <div className="text-2xl text-red-500 font-semibold mb-6">
                  ${price}
                </div>
                <p className="mb-8 text-gray-700 leading-relaxed text-justify">
                  {description}
                </p>
                <button
                  onClick={() =>
                    addToCart(product, product.id) &&
                    toast.success("Added to cart!")
                  }
                  className="bg-primary py-4 px-8 text-white font-semibold rounded hover:bg-primary-dark transition duration-300"
                >
                  Add to cart
                </button>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default ProductDetails;
